<ng-container *ngIf="question">
  <!-- THIS IS JUST SO THE FORM GETS CREATED CORRECTLY AND NO ERRORS SHOW IN THE CONSOLE -->
  <!-- SHOULDN'T BE NECESSARY IF ALL QUESTION GROUPS ARE MATCHED APPROPRIATELY -->
  <div [formGroup]="form" style="visibility: hidden; height: 0">
    <div [formGroupName]="type" *ngIf="!question.isMultipleChoice">
      <ng-container *ngFor="let answer of question.answers">
        <input type="text"
               [value]="answer"
               [formControlName]="parentQuestion ? parentQuestion.id+'-'+question.id : question.id" />
      </ng-container>

      <div *ngIf="followUp" class="follow-up-form-item">
        <ol>
          <li *ngFor="let childQuestion of question.childQuestions; let x = index;">
            <cz-unknown-question-group [type]="type"
                                       [question]="childQuestion"
                                       [parentQuestion]="question"
                                       [form]="form"
                                       [imagePath]="childQuestion.imagePath">
            </cz-unknown-question-group>
          </li>
        </ol>
      </div>
    </div>

    <div [formGroupName]="type" *ngIf="question.isMultipleChoice">
      <div [formGroupName]="parentQuestion ? parentQuestion.id+'-'+question.id : question.id">
        <ng-container *ngFor="let answer of question.answers">
          <input id="{{type}}-{{question.id}}-{{answer.id}}"
                 [formControlName]="answer.id"
                 type="checkbox" />
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
<span>{{ '$evaluation_no_questions_configured' | translate }}</span>
